import React from 'react';

import { Field } from 'redux-form';

import { CSSTransitionGroup } from 'react-transition-group';

import * as validator from 'helpers/Validator';

import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';

import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import OutlinedSelect from 'helpers/reduxFormMaterialUiNext/OutlinedSelect';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

import { VEHICLE_TYPES } from 'constants/vehicleTypes.constants';

const style = {
  addVehicleButton: {
    color: 'white',
  },
};

export const VehiclesFieldArrayOutlined = ({
  fields,
  meta: { touched, error, submitFailed },
  outlined,
}) => {
  return (
    <div className="row">
      <CSSTransitionGroup
        transitionName="add_vehicle"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={500}
      >
        {fields.map((vehicle_information, index) => (
          <div key={index} className="row">
            <div style={{ padding: '0 15px' }}>
              <h4 style={{ lineHeight: '26px' }}>
                {getTranslatedString('landlordPortal.vehicles.vehicleNo')}
                {index + 1}
                <IconButton
                  style={{
                    padding: 0,
                    verticalAlign: 'text-bottom',
                    width: 'none',
                    height: 'none',
                    float: 'right',
                  }}
                  onClick={() => fields.remove(index)}
                >
                  <DeleteIcon size={24} style={{ padding: 0 }} />
                </IconButton>
              </h4>
            </div>

            <div className="row" style={{ marginBottom: '10px' }}>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${vehicle_information}.make`}
                  type="text"
                  component={TextField}
                  label={getTranslatedString('landlordPortal.vehicles.makeModel')}
                  style={{ marginTop: '10px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${vehicle_information}.vehicle_type`}
                  type="text"
                  component={OutlinedSelect}
                  label={getTranslatedString('landlordPortal.vehicles.type')}
                  style={{ marginTop: '10px', fontSize: '14px', textAlign: 'initial' }}
                  validate={[validator.required]}
                >
                  {VEHICLE_TYPES.map((type) => (
                    <MenuItem value={type.value} primaryText={type.primaryText} />
                  ))}
                </Field>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${vehicle_information}.color`}
                  type="text"
                  component={TextField}
                  label={getTranslatedString('landlordPortal.vehicles.color')}
                  style={{ marginTop: '10px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                  variant="outlined"
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${vehicle_information}.plate_number`}
                  type="text"
                  component={TextField}
                  label={getTranslatedString('landlordPortal.vehicles.plateNumber')}
                  style={{ marginTop: '10px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                  validate={[validator.required]}
                  variant="outlined"
                />
              </div>
            </div>
          </div>
        ))}
      </CSSTransitionGroup>
      <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
        <FlatButton
          label={getTranslatedString('landlordPortal.vehicles.addVehicle')}
          type="button"
          id="vehicle-button"
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={style.addVehicleButton}
          onClick={() => {
            fields.push({});
          }}
        />

        {error && (
          <p
            style={{
              marginTop: '10px',
              fontSize: '11px',
              color: AccentColor(),
            }}
            id="errorMessage"
          >
            {error}
          </p>
        )}
      </div>
    </div>
  );
};
